import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Alert, AlertLevel } from '../../models/alerts';
import { ALERT_LEVEL_META, AlertLevelMeta } from '../../models/alert-level.util';
import { CommonModule } from '@angular/common';

// The toast-card stack (loading/error/empty/list states) shared by the admin desktop preview
// dialog, the admin mobile Preview tab, and the real-time end-user toast stack in the shell
// (DEV-1165 Phase 2) — extracted so the identical card markup/styling isn't duplicated across
// all three. Purely presentational: each data-fetching "smart" parent owns the actual
// alerts-fetching call and dismissal state.
@Component({
  selector: 'app-alert-preview-stack',
  standalone: true,
  imports: [MatIcon, MatProgressSpinner, CommonModule],
  templateUrl: './alert-preview-stack.component.html',
  styleUrl: './alert-preview-stack.component.scss'
})
export class AlertPreviewStackComponent {
  @Input() loading = false;
  @Input() hasError = false;
  @Input() alerts: Alert[] = [];
  @Output() dismiss = new EventEmitter<number>();

  levelMeta(level: AlertLevel): AlertLevelMeta {
    return ALERT_LEVEL_META[level];
  }
}
